// Экран входа: ввод кодовой фразы. После успеха фраза запоминается, экран уходит.

import { useState, type FormEvent } from 'react'
import { setAccessKey, verifyKey } from '../net/access'

export function AccessGate({ onUnlock }: { onUnlock: () => void }) {
  const [value, setValue] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    const key = value.trim()
    if (!key || busy) return
    setBusy(true)
    setError(null)
    const ok = await verifyKey(key)
    setBusy(false)
    if (ok) {
      setAccessKey(key)
      onUnlock()
    } else {
      setError('Неверная фраза доступа')
    }
  }

  return (
    <div className="gate">
      <form className="gate__card" onSubmit={submit}>
        <div className="gate__lock" aria-hidden="true">🔒</div>
        <h1 className="gate__title">Доступ к агенту</h1>
        <p className="gate__hint">Введите кодовую фразу</p>
        <input
          className="gate__input"
          type="password"
          inputMode="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Кодовая фраза"
          autoComplete="current-password"
          autoFocus
          disabled={busy}
          aria-label="Кодовая фраза доступа"
        />
        <button className="gate__btn" type="submit" disabled={busy || !value.trim()}>
          {busy ? 'Проверка…' : 'Войти'}
        </button>
        {error && <p className="gate__error">{error}</p>}
      </form>
    </div>
  )
}
